import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'styles/pages/Events/MembersMeeting/MembersMeeting.module.scss'

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Events/MembersMeeting/components/SectionHeader'));
const SectionArticles = dynamic(() => import('sections/Events/MembersMeeting/components/SectionArticles'));
const SectionAgenda = dynamic(() => import('sections/Events/MembersMeeting/components/SectionAgenda'));

export default function MembersMeetingPage() {
  return (
    <div className={cn('members-meeting')}>
      <SectionHeader/>
      <SectionArticles/>
      <SectionAgenda/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      path: '/events/members-meeting',
      title: 'Attend the DF Alliance Members Meeting | DF Alliance',
      description:
        "Join DF Alliance's Members Meeting to connect with global logistics leaders, share industry knowledge, and discuss the latest developments in freight forwarding.",
    },
  };
};

MembersMeetingPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
